"use client";

import { useResponsiveAttribs } from "@/hooks/useResponsiveAttribs";

const ResponsiveDim = () => {
  useResponsiveAttribs();
  return <></>;
};

export default ResponsiveDim;
